import { render, staticRenderFns } from "./SupporterTableItem.vue?vue&type=template&id=369215f7&scoped=true"
import script from "./SupporterTableItem.vue?vue&type=script&lang=js"
export * from "./SupporterTableItem.vue?vue&type=script&lang=js"
import style0 from "./SupporterTableItem.vue?vue&type=style&index=0&id=369215f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369215f7",
  null
  
)

export default component.exports